import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Box } from '@mui/material';
import { SimCard } from '@mui/icons-material';
import { AccordionWithValidation } from 'console/device-settings/z3k/components/material-utils/accordion-with-validation';
import { AccordionHeader } from './accordion-header';
import { SettingContainer } from 'console/device-settings/z3k/components/material-utils/settings-card/container';
import { SettingFullRow } from 'console/device-settings/z3k/components/material-utils/settings-card';
import { SimInfo } from 'shared/components/indicators/gsm/with-info/sim-info';
import { useGetSimInDevice } from 'console/sim/utils/select-sim';
import { usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { simProblemStatusState, simProblemStatusText, } from 'console/sim/utils/sim-problem';
export const SimSettings = memo(function SimAccordion(props) {
    const { device_id } = props;
    const [billed_sim, foreign_sim] = useGetSimInDevice(device_id);
    const sim_status = usePartialAppSelector(simProblemStatusState, device_id);
    const sim_status_text = usePartialAppSelector(simProblemStatusText, device_id);
    return (_jsx(AccordionWithValidation, { header: _jsx(AccordionHeader, { icon: _jsx(SimCard, {}), heading: "\u0421\u0438\u043C-\u043A\u0430\u0440\u0442\u0430", subheading: billed_sim != null
                ? `+${billed_sim.sim_card.msisdn}`
                : foreign_sim != null
                    ? `+${foreign_sim.msisdn}`
                    : 'не выбрана' }), validation_result: sim_status == 'error' ? sim_status_text : null, validation_warnings_result: sim_status == 'warning' ? sim_status_text : null, children: _jsx(SettingContainer, { children: _jsx(SettingFullRow, { children: _jsx(Box, { display: "flex", gap: 2, children: _jsx(SimInfo, { device_id: device_id }) }) }) }) }));
});
